import React from "react";
import ButtonComp from "./ButtonComp";
import ReactHtmlParser from "react-html-parser";

const ContentImageSection = ({
  contentSection,
  quoteText,
  paragraphs = [],
  listSectionTitle,
  listColumns = [],
  listSingleColumn = false,
  btnLink,
  btnText,
  btnClassName,
  image,
  imageClassName,
  reverse = false,
  listBottomText
}) => {
  return (
    <div className={`align-items-center justify-content-between row content-image-section ${reverse ? "flex-row-reverse" : ""}`}>
      {/* LEFT CONTENT */}
      <div className="col-lg-5 col-md-12 mb-4 mb-lg-0">
        {/* {(highlightText || title) && (
          <h1 className="hero-title">
            {highlightText && <span className="text-success FS40FW600">{highlightText}</span>}
            {highlightText && title && <br />}
            {title}
          </h1>
        )} */}
        {contentSection && contentSection()}
        {quoteText && (
          <div
            className="quote-box mt-3 FS18FW400 black"
            dangerouslySetInnerHTML={{ __html: quoteText }}
          />
        )}

        {paragraphs.map((text, i) => (
          <p key={i} className="mt-3 FS17FW500 quote-para" dangerouslySetInnerHTML={{ __html: text }} />
        ))}

        {listColumns.length > 0 && (
          <>
            {listSectionTitle && <p className="mt-3 FS17FW500 quote-para">{listSectionTitle}</p>}
            <div className={`cis-list-columns quote-list ${listSingleColumn ? "cis-list-single" : "d-flex gap-3"}`}>
              {listColumns.map((col, i) => (
                <ul key={i} className="feature-list">
                  {col.map((item, j) => (
                    <li key={j} className="FS16FW500 fw-normal">{item}</li>
                  ))}
                </ul>
              ))}
            </div>
          </>
        )}
        {listBottomText && (
          <div className="mt-3"><span className="quote-para FS17FW500">{ReactHtmlParser(listBottomText)}</span></div>
        )}
        {btnLink && btnText && (
          <ButtonComp link={btnLink} btnText={btnText} className={btnClassName} />
        )}
      </div>

      {/* RIGHT IMAGE */}
      {image && (
        <div className="col-lg-6 col-md-12 cis-image-col">
          <img className={`cis-image ${imageClassName || ""}`} src={image} alt={"LA"} />
        </div>
      )}
    </div>
  );
};

export default ContentImageSection;
